import { render, staticRenderFns } from "./After.vue?vue&type=template&id=316693d2&scoped=true&"
import script from "./After.vue?vue&type=script&lang=js&"
export * from "./After.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316693d2",
  null
  
)

export default component.exports